import { render, staticRenderFns } from "./UserContactProps.vue?vue&type=template&id=859d3164&"
import script from "./UserContactProps.vue?vue&type=script&lang=js&"
export * from "./UserContactProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports